import { useEffect } from "react";
import "flowbite"; // Import Flowbite for initialization

const FAQAccordion = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      import("flowbite").then((module) => {
        if (module && module.initAccordions) {
          module.initAccordions();
        }
      });
    }
  }, []);

  return (
    <section id="FAQs" className="bg-white dark:bg-gray-900 pb-8">
      <div className="max-w-screen-xl mx-auto lg:py-20 lg:px-6">
        <h2 className="mb-6 text-3xl font-extrabold tracking-tight text-center text-gray-900 lg:mb-8 lg:text-3xl">
          FAQs
        </h2>
        <div className="max-w-screen-md mx-auto">
          <div
            id="accordion-flush"
            data-accordion="collapse"
            data-active-classes="bg-white dark:bg-gray-900 text-title-purple dark:text-white"
            data-inactive-classes="text-gray-500 dark:text-gray-400"
          >
            {/* Accordion Item 1 */}
            <h3 id="accordion-flush-heading-1">
              <button
                type="button"
                className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200"
                data-accordion-target="#accordion-flush-body-1"
                aria-expanded="false"
                aria-controls="accordion-flush-body-1"
              >
                <span>What industries do you work with?</span>
                <svg data-accordion-icon="" className="w-6 h-6 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path>
                </svg>
              </button>
            </h3>
            <div id="accordion-flush-body-1" className="hidden" aria-labelledby="accordion-flush-heading-1">
              <div className="py-5 border-b border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400">
                <p>We work across various industries, including finance, legal, real estate, e-commerce, and professional services - any business looking to enhance efficiency and data-driven decision-making. We bring incredible value with transferable knowledge across business.</p>
              </div>
            </div>

            {/* Accordion Item 2 */}
            <h3 id="accordion-flush-heading-2">
              <button
                type="button"
                className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
                data-accordion-target="#accordion-flush-body-2"
                aria-expanded="false"
                aria-controls="accordion-flush-body-2"
              >
                <span>What tools do you use and build solutions in?</span>
                <svg data-accordion-icon="" className="w-6 h-6 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path>
                </svg>
              </button>
            </h3>
            <div id="accordion-flush-body-2" className="hidden" aria-labelledby="accordion-flush-heading-2">
              <div className="py-5 border-b border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400">
              <p class="mb-2 text-gray-500 dark:text-gray-400">We leverage a wide range of powerful tools to develop customised solutions, including:<br/>
                <ol class="list-decimal pl-5">
                    <li>✅ Data Analytics & Visualization: Google Data Studio, Tableau, QlikView</li>
                    <li>✅ Automation & Scripting: Python, Alteryx, Google Apps Script, VBA, Selenium, Xceptor, Zapier</li>
                    <li>✅ Data Processing & Management: Excel, SQL</li>
                    <li>✅ AI & Machine Learning: ChatGPT, Alteryx</li>
                    <li>✅ Marketing & Advertising: Google Analytics, Facebook, Instagram, LinkedIn, Google Ads</li>
                </ol>
                <br/><br/>By integrating these tools, we create efficient, scalable, and data-driven solutions tailored to your business needs.</p>
              </div>
            </div>

            {/* Accordion Item 3 */}
            <h3 id="accordion-flush-heading-3">
              <button
                type="button"
                className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
                data-accordion-target="#accordion-flush-body-3"
                aria-expanded="false"
                aria-controls="accordion-flush-body-3"
              >
                <span>Can you customise solutions for my business?</span>
                <svg data-accordion-icon="" className="w-6 h-6 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path>
                </svg>
              </button>
            </h3>
            <div id="accordion-flush-body-3" className="hidden" aria-labelledby="accordion-flush-heading-3">
              <div className="py-5 border-b border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400">
              <p class="mb-2 text-gray-500 dark:text-gray-400">Absolutely! We tailor our services to fit your specific needs, ensuring that automation and analytics solutions align with your business goals and operational challenges.</p>
              </div>
            </div>

            {/* Accordion Item 4 */}
            <h3 id="accordion-flush-heading-4">
              <button
                type="button"
                className="flex items-center justify-between w-full py-5 font-medium text-left text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
                data-accordion-target="#accordion-flush-body-4"
                aria-expanded="false"
                aria-controls="accordion-flush-body-4"
              >
                <span>How can I get started with your services?</span>
                <svg data-accordion-icon="" className="w-6 h-6 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path>
                </svg>
              </button>
            </h3>
            <div id="accordion-flush-body-4" className="hidden" aria-labelledby="accordion-flush-heading-4">
              <div className="py-5 border-b border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400">
              <p class="mb-2 text-gray-500 dark:text-gray-400">It's simple - book a free Discovery Session using our&nbsp;
                <a className="inline-block mt-4 text-title-purple hover:underline" href="https://www.mydatapulse.co.uk/appointment" target="_blank" rel="noopener noreferrer">
                  booking link
                </a>
                . We'll explore your challenges, uncover opportunities, and share a tailored plan to help your business grow through smart automation. 🚀</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQAccordion;
